import { type MessageDescriptor, type WrappedComponentProps } from 'react-intl-next';

export enum ItemModuleCompleteKeys {
	BLANK_PAGE = 'com.atlassian.confluence.plugins.confluence-create-content-plugin:create-blank-page',
	PRODUCT_REQUIREMENTS = 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-item',
	DECISION = 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint-item',
	MEETING_NOTES = 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-item',
	RESTROSPECTIVE = 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-item',
}

export enum BlueprintModuleCompleteKeys {
	PRODUCT_REQUIREMENTS = 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
	DECISION = 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
	MEETING_NOTES = 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
	RESTROSPECTIVE = 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',
}

export type BlueprintModuleCompleteKey = BlueprintModuleCompleteKeys | null;

export type ItemModuleCompleteKey = ItemModuleCompleteKeys | null;

export type WithIntlProps<T> = T & WrappedComponentProps;

export interface GenericButtonOptions {
	text: MessageDescriptor;
	onClick: () => void;
	isLoading: boolean;
	onReady?: () => void;
}
